const galleryData = [
    {
        title:"Lorem ipsum",
        img:"assets/images/Gallery/pic1.png"
    },
    {
        title:"Lorem ipsum",
        img:"assets/images/Gallery/pic2.png"
    },
    {
        title:"Lorem ipsum",
        img:"assets/images/Gallery/pic3.png"
    },
    {
        title:"Lorem ipsum",
        img:"assets/images/Gallery/pic4.png"
    },
    {
        title:"Lorem ipsum",
        img:"assets/images/Gallery/pic5.png"
    },
    {
        title:"Lorem ipsum",
        img:"assets/images/Gallery/pic6.png"
    },
    {
        title:"Lorem ipsum",
        img:"assets/images/Gallery/pic7.png"
    },
    {
        title:"Lorem ipsum",
        img:"assets/images/Gallery/pic8.png"
    },
    {
        title:"Lorem ipsum",
        img:"assets/images/Gallery/pic9.png"
    }
];

export default galleryData;